import { RefObject, useCallback } from 'react';

export default function useScrollToNextElement(
  containerRef: RefObject<HTMLElement | null>,
): (direction: 'left' | 'right') => void {
  return useCallback(
    (direction: 'left' | 'right') => {
      const container = containerRef.current;
      if (!container) return;

      const HTMLElementWidth = container.clientWidth;
      const nextScrollLeft = Math.max(
        0,
        container.scrollLeft + (direction === 'right' ? HTMLElementWidth : -HTMLElementWidth),
      );

      container.scrollTo({ left: nextScrollLeft, behavior: 'smooth' });
    },
    [containerRef],
  );
}
